<template lang="pug"> 
  title-tab(:msg="$t('title.withdraw')")
    v-row(no-gutters).wd-space
      v-col.px-1(cols='12', md='6')
        v-card.mt-3.py-2(v-if='userProfile.bank_type' flat)
          v-row.mx-3.pb-2
            v-col(cols='6') {{ $t('your-credit-balance') }}
            v-col(cols='6' align="end") {{ wallet.amount ? wallet.amount : 0 | currency }} {{ $t('unit.baht') }}
          v-divider
          v-row.ma-3
            v-col(cols='3' align="center")
              v-avatar
                v-img(:src='bankIconPath(userProfile.bank_type.id)')
            v-col(cols='9')
              v-row
                h5 {{ $t('bank') }}{{ userProfile.bank_type.name }}
              v-row
                h5 {{ $t('account-name') }} :  
                h5.blue--text.ml-1 {{ userProfile.bank_name }}
              v-row
                h5 {{ $t('account-number') }} : 
                h5.blue--text.ml-1 {{ userProfile.bank_number }}
      v-col.px-1
        v-card.py-2.mt-3(v-if='userProfile.credit_request_condition' flat)
          v-row.pb-2.mx-3(align="center")
            v-col(cols='6') {{ $t('fill-money') }}
            v-col.red--text(cols='6' align="end") {{ $t('minimum-withdraw') }} {{ userProfile.credit_request_condition.min_withdraw_amount }} {{ $t('unit.baht') }}
          v-divider
          .ma-3
            v-row(justify="center")
              v-col(
                v-for='item in selectTabAmount'
                :key='item'
                cols="3"
                align="center"
              )
                v-btn-toggle(
                  v-model='form.request_amount'
                  color="var(--bg-secondary-color)"
                )
                  v-btn.ma-3.force-round( 
                    :value='item'
                    @click="GA('SelectAmount',item)"
                  ) {{ item }}
            v-form(@submit.prevent)
              h4 {{ $t('fill-amount') }}
              n-number-field-specific(
                v-model='form.request_amount'
                :error-messages='amountErrorMessage'
                prevent-paste
                :suffix="$t('unit.baht')"
                :placeholder="$t('placeholder.fill-amount')"
              )
              
              //- v-text-field(
              //-   v-model='form.request_description'
              //-   dense 
              //-   outlined
              //-   :placeholder="$t('placeholder.note')"
              //- )
              v-btn(
                type='submit'
                block
                dark
                depressed
                :disabled='submitstatus'
                :loading='submitstatus'
                color='var(--bg-secondary-color)'
                @click='submit'
              ) {{ $t('button.withdraw') }}
    dialog-promotion-lock(ref='dialogPromotionLockRef')

</template>
<script>  
import { bankIconPath } from '@/plugins/mapImage'  
import { credits as apiCredits, users as apiUsers } from '@/apis'
import { ROUTE_SETTING } from '../../../const/route'
import DialogPromotionLock from '@/components/Promotion/DialogPromotionLock'

export default { 
  components : {
    DialogPromotionLock,
  },
  data: () => ({
    selectTabAmount : [100,300,500,1000],
    form:{
      request_amount: null,
      request_description:null
    }, 
    amountErrorMessage : undefined, 
    submitstatus:false
  }), 
  computed : {
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    request_amount () {
      return this.form.request_amount
    }
  }, 
  watch : {
    request_amount () {
      let condition = (this.userProfile || {}).credit_request_condition
      if(
        this.request_amount!== null
        &&this.request_amount>=parseInt(condition.min_withdraw_amount)
        &&this.request_amount<=parseInt(condition.max_withdraw_amount)
      ) {
        this.amountErrorMessage = undefined
      }
    }
  }, 
  mounted () {
    this.init()
  },
  methods : { 
    bankIconPath,
    init () {

      if (this.userProfile.bank_type === null) {
        this.$alert('กรุณาตั้งค่าบัญชีธนาคารของท่าน','', 'warning').then(() => {
          this.$router.push({ name: ROUTE_SETTING, query: { tab: 'bank' } }).catch(() => {}); 
        });
      }
    },      
    GA (actions,item){
      this.$ga.event('Button', actions, 'WithdrawPage',item)
    }, 
    async submit () { 
      let condition = (this.userProfile || {}).credit_request_condition || {}
      this.submitstatus = true
      this.$ga.event('Submit', 'Withdraw', 'WithdrawPage','')
      if
      (this.request_amount !== undefined
      && this.request_amount >= parseInt(condition.min_withdraw_amount)
      && this.request_amount <= parseInt(condition.max_withdraw_amount)
      && parseInt(this.request_amount)<=this.wallet.amount
      ) { 
        const [err,,,,status] = await apiCredits.withdraw(this.form)

        this.submitstatus = false 

        if (status == 409) {
          this.requestVerifyDemo()
          return
        }

        if (status == 423) {
          this.$refs.dialogPromotionLockRef.open()
          return
        }

        if(err){
          this.$alert('',err,'warning')
          return
        }

        this.$store.dispatch('userProfile/ACTION_WALLET') 
        this.$emit('success')

      } else if(this.request_amount === undefined){ 
        this.amountErrorMessage = this.$t('validate.please-enter-number')
        this.submitstatus = false
      } else if(this.request_amount < parseInt(condition.min_withdraw_amount)){
        this.amountErrorMessage = `${this.$t('validate.minimum-amount-can-withdraw-is')} ${condition.min_withdraw_amount} ${this.$t('unit.baht')}`
        this.submitstatus = false
      } else if(this.request_amount > parseInt(condition.max_withdraw_amount)){
        this.amountErrorMessage = `${this.$t('validate.maximum-amount-can-withdraw-is')} ${condition.max_withdraw_amount} ${this.$t('unit.baht')}`
        this.submitstatus = false
      } else {
        this.amountErrorMessage = this.$t('validate.money-not-enough')
        this.submitstatus = false
      }
    },    
    async requestVerifyDemo () {
      const [err,data] = await apiUsers.getDemoUserVerify()

      if(err) { 
        this.$alert('',err,'warning')  
        return
      }  

      this.$alert('',data,'success')
    },
  }
}
</script> 
<style scoped>
.wd-space {
  margin-bottom: 70px;
}
</style>